/**
 * @changelog
 *
 * 2026-09-23 (0.1.0) (jhoward)
 *   - Add new src\helpers\isOfferPending.ts to determine if an offer is PENDING, i.e. not live for patrons yet.
 */

import type { OpcOffer } from '@/defs/api/OpcOffer';

//The server only sends PENDING offers to admins, so a pending offer on screen means an admin is looking at it.
export default function isOfferPending(offer: OpcOffer): boolean {
  return 'PENDING' === offer.OFFER_COPY_STATUS;
}
